import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { removeFormErrors } from "store/form/actions";

import { useOutsideClickHook } from "utils/outsideClick";
import { useStateSelector } from "utils/field";

import DropDown from "components/Dropdown";
import Dialog, { CloseDialog } from "components/Dialog";
import Button from "components/Button";

import classes from "./style.module.scss";

import Delete from "assets/images/icons/JSX/Delete";

export default React.memo(({ accessor, change }) => {
    const dispatch = useDispatch();

    const [menuOpen, toggleMenuOpen] = useState(false);
    const [deleteDialogOpen, toggleDeleteDialog] = useState(false);

    const ref = useOutsideClickHook(() => toggleMenuOpen(false));

    const vehicleAccessor = "model.modelData.transportation.vehicles";
    const Vehicles = useStateSelector(vehicleAccessor) || {};

    const handleDelete = () => {
        const filteredVehicles = Object.entries(Vehicles).reduce((acc, [key, value]) => {
            if (key === accessor.split("vehicles.")[1]) {
                return acc;
            }
            return {
                ...acc,
                [key]: value,
            };
        }, {});

        //if is upgrade, path is of the form fields.Vehicles.vehicleId
        //fixes bug that prevented system delete in upgrades table
        //const deleteAccessor = isUpgrade ? "fields.vehicles" : `model.modelData.transportation.vehicles`;
        const deleteAccessor = `model.modelData.transportation.vehicles`;

        change(deleteAccessor, filteredVehicles);
        dispatch(removeFormErrors(deleteAccessor));
    };

    return (
        <div className={classes.actions} ref={ref}>
            <div className={classes.menu}>
                <div className={classes.dots} onClick={() => toggleMenuOpen(!menuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <DropDown
                    className={classes.dropDown}
                    open={menuOpen}
                    toggleOpen={toggleMenuOpen}
                    options={[
                        {
                            label: (
                                <span>
                                    <Delete /> Delete
                                </span>
                            ),
                            className: classes.delete,
                            onClick: () => toggleDeleteDialog(true),
                        },
                    ]}
                />
            </div>
            <Dialog open={deleteDialogOpen}>
                <CloseDialog closeActions={() => toggleDeleteDialog(false)} />
                <div className={classes.dialog}>
                    <h3>Are you sure you want to delete this vehicle?</h3>
                    <div className={classes.footer}>
                        <Button type="hollow" onClick={() => toggleDeleteDialog(false)}>
                            Cancel
                        </Button>
                        <Button onClick={() => handleDelete()} type="red">
                            Delete
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
});
